import script from "./ProductionSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ProductionSidebar.vue?vue&type=style&index=0&id=7bde2a26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bde2a26"]])

export default __exports__